import React, { useState, useEffect } from "react";

//
import { Card, Col, Row, Form, Button, Spinner } from "react-bootstrap";
import { useDropzone } from "react-dropzone";

//
import PageHeader from "../../../components/general/PageHeader";
import BoxLoading from "../../../components/general/BoxLoading";
import FilterDropdown from "../../../components/general/FilterDropdown";

//
import {
  getDepartments,
  sendNewTicket,
} from "../../../redux/features/tickets/actions";

//
import { Formik } from "formik";
import * as yup from "yup";

//
const schema = yup.object().shape({
  title: yup.string().required(),
  message: yup.string().required(),
});

function NewTicket() {
  const [loading, setloading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  //
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState({});

  //
  const [files, setFiles] = useState([]);
  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    maxSize: 2097152,
    onDrop: (acceptedFiles) => {
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  /**
   * Send New Ticket
   */
  const send_new_ticket = async (e, { resetForm }) => {
    // start loading
    setBtnLoading(true);

    // set variable
    let fd = new FormData();
    fd.append("department", selectedDepartment.value);
    fd.append("title", e.title);
    fd.append("message", e.message);
    if (files.length) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        fd.append("imageFile[]", file);
      }
    }

    // request
    await sendNewTicket(fd).then((res) => {
      if (res) {
        resetForm({
          values: "",
        });

        setFiles([])
      }
    });

    // stop loading
    setBtnLoading(false);
  };

  /**
   * Get Depatments
   */
  const get_departments = async () => {
    // start loading
    setloading(true);

    // request
    await getDepartments().then((res) => {
      if (res) {
        let array = [];

        for (let i = 0; i < res.length; i++) {
          const element = res[i];
          array.push({
            name: element.charAt(0).toUpperCase() + element.slice(1),
            value: element,
          });
        }

        setDepartments(array);
        setSelectedDepartment(array[0]);
      }
    });

    // stop loading
    setloading(false);
  };

  useEffect(() => {
    get_departments();

    // eslint-disable-next-line
  }, []);


  const removeFile = file => {
    let newFiles = [...files];     // make a var for the new array
    newFiles = newFiles.filter((item) => item != file);     // remove the file from the array  
    setFiles(newFiles);              // update the state
  };

  useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks
    files.forEach((file) => URL.revokeObjectURL(file.preview));
  }, [files]);

  return (
    <div id="new-ticket">
      <PageHeader
        title="New Ticket (Support Message)"
      />

      <Card id="tickets-main-card">
        <Card.Body>
          <Formik
            validationSchema={schema}
            onSubmit={send_new_ticket}
            initialValues={{
              title: "",
              message: "",
            }}
          >
            {({ handleSubmit, handleChange, touched, errors, values }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <Row>
                  {/* Title */}
                  <Col md={6}>
                    <Form.Group
                      className="form-group"
                      controlId="validationFormik1"
                    >
                      <Form.Label>Title</Form.Label>
                      <Form.Control
                        type="text"
                        name="title"
                        placeholder="Title"
                        className="form-control"
                        onChange={handleChange}
                        autoComplete="off"
                        value={values.title}
                        isInvalid={touched.title && !!errors.title}
                      />
                    </Form.Group>
                  </Col>

                  {/* Department */}
                  <Col md={6}>
                    <Form.Group
                      className="form-group"
                      controlId="validationFormik0"
                    >
                      <Form.Label>Department</Form.Label>
                      <FilterDropdown
                        filters={departments}
                        activeFilter={selectedDepartment}
                        action={(item) => setSelectedDepartment(item)}
                        full
                        fit
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* Message */}
                <Form.Group
                  className="form-group"
                  controlId="validationFormik2"
                >
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={7}
                    name="message"
                    placeholder="Message"
                    className="no-resize"
                    onChange={handleChange}
                    value={values.message}
                    isInvalid={touched.message && !!errors.message}
                  />
                </Form.Group>

                <Card className="dropzone bordered mb-4">
                  <Card.Body className="text-center">
                    <div {...getRootProps({className: 'clickable'})}></div>
                    <input {...getInputProps()} />
                    {files.length ? (
                      <div className="thump-box">
                        {files.map((file) => (
                          <div className="thump" key={file.name}>
                            <div className="item">
                              <img src={file.preview} />
                            </div>

                            <div className="remove-box">
                              <i className="las la-times-circle" onClick={() => removeFile(file)}></i>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="input-text">
                        {" "}
                        <span className="text-info pointer">
                          Click to replace
                        </span>{" "}
                        or drag and drop
                      </div>
                    )}
                  </Card.Body>
                </Card>

                <Button type="submit" variant="info" size="lg">
                  Submit
                  {btnLoading && (
                    <div className="spinner-holder">
                      <Spinner animation="border" variant="white" size="sm" />
                    </div>
                  )}
                </Button>
              </Form>
            )}
          </Formik>
        </Card.Body>

        {loading && <BoxLoading />}
      </Card>
    </div>
  );
}

export default NewTicket;
